import { Button, Notification } from '@electronicpartnerio/uic';
import { epFetch } from '@electronicpartnerio/ui-utils';

const loginForm = async (loginFormEl: HTMLFormElement) => {
    const notification: Notification = loginFormEl.querySelector('uic-notification')!;
    const button: Button = loginFormEl.querySelector('#submit')!;

    const formField: HTMLCollectionOf<HTMLDivElement> = loginFormEl.getElementsByClassName(
        'form-field'
    ) as HTMLCollectionOf<HTMLDivElement>;

    const handleFormSubmit = async (e: Event) => {
        e.preventDefault();
        const payload: { [k: string]: string } = {};

        Array.from(formField).forEach((formField: HTMLDivElement) => {
            const input: HTMLInputElement = formField.querySelector('input')!;
            const name = input.getAttribute('name')!;
            const err: HTMLInputElement = formField.querySelector('.err')!;
            const value = input.value.trim();
            const isValid = value !== '';

            if (isValid) {
                payload[name] = value;
            }
            err.classList.toggle('hidden', isValid);
            formField.classList.toggle('error', !isValid);
        });

        if (Object.keys(payload).length !== formField.length) {
            return;
        }

        notification.classList.add('hidden');
        button.setAttribute('loading', '');

        const init: RequestInit = {
            method: 'POST',
            body: JSON.stringify(payload)
        };
        const fetcher = epFetch('login');
        await fetcher(``, init)
            .then(({ target, token }) => {
                if (token) {
                    localStorage.setItem('jwt', token);
                }
                window.location.href = target || '/';
            })
            .catch((err) => {
                let parsedError: { key?: string | number; error?: string } | null = null;
                try {
                    parsedError = JSON.parse(err.message);
                } catch {}

                if (parsedError && parsedError.error) {
                    notification.setAttribute('heading', parsedError.error);
                }

                notification.classList.remove('hidden');
                button.removeAttribute('loading');
                console.error(err.message);
            });
    };

    const initFormField = (formField: HTMLDivElement) => {
        const input: HTMLInputElement = formField.querySelector('input')!;
        const err: HTMLInputElement = formField.querySelector('.err')!;
        const btn = formField.querySelector('uic-button');
        const icon = formField.querySelector('uic-icon');
        let isProtected = true;
        let intValCount: number = 0;

        const setActiveClass = () => {
            const value = input.value;
            const active = !!value;
            formField.classList.toggle('active', active);
            intValCount += 1;

            if (active || intValCount >= 10) {
                window.clearInterval(intVal);
            }
        };

        const map: Record<string, { attr: string; type: string }> = {
            true: {
                attr: 'visibility',
                type: 'password'
            },
            false: {
                attr: 'visibility_off',
                type: 'text'
            }
        };

        const handleOnInput = () => setActiveClass();
        const handleOnBlurAndChange = () => {
            const { value } = input;
            const isValid = value.trim() !== '';
            err.classList.toggle('hidden', isValid);
            formField.classList.toggle('error', !isValid);
            setActiveClass();
        };
        const handleBtnClick = () => {
            isProtected = !isProtected;
            const { attr, type } = map[String(isProtected)];

            icon!.setAttribute('name', attr);
            input.type = type;
        };

        input.addEventListener('input', handleOnInput);
        input.addEventListener('change', handleOnBlurAndChange);
        input.addEventListener('blur', handleOnBlurAndChange);
        const intVal: ReturnType<typeof setTimeout> | number = window.setInterval(setActiveClass, 400);
        btn?.addEventListener('click', handleBtnClick);
        setActiveClass();
    };

    const initForm = () => {
        loginFormEl.addEventListener('submit', handleFormSubmit);
        button.addEventListener('onClick', handleFormSubmit);

        Array.from(formField).forEach(initFormField);
    };

    initForm();
};

export default loginForm;
